import * as React from 'react';
import { TableFilter } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils';
import { Checkbox } from '../../Checkbox/src/Checkbox.js';
import { Dropdown } from '../../Dropdown/src/Dropdown.js';
import modules_3ddbb815 from '../styles/Filter.module.less.js';

const Filter = ({ column }) => {
    const { options, enableColumnFilter } = column.columnDef;
    const columnFilterValue = column.getFilterValue();
    const sortedUniqueValues = React.useMemo(() => (enableColumnFilter ? Array.from(column.getFacetedUniqueValues().keys()).sort().slice(0, 5000) : []), [column, enableColumnFilter]);
    const cx = useStyles(modules_3ddbb815);
    const iconClassNames = cx('icon', {
        filtered: column.getIsFiltered(),
    });
    // dynamically generated select options from faceted values feature
    const innerOptions = React.useMemo(() => {
        if (options) {
            return options;
        }
        const uniqueOptions = [];
        uniqueOptions.push({
            label: 'Все',
            value: '',
            control: React.createElement(Checkbox, null),
        });
        sortedUniqueValues.forEach((value) => value &&
            uniqueOptions.push({
                label: value,
                value,
                control: React.createElement(Checkbox, null),
            }));
        return uniqueOptions;
    }, [options, sortedUniqueValues]);
    if (!enableColumnFilter && !options?.length) {
        return null;
    }
    const hanldeFilterChange = (newValue) => {
        if (newValue === '') {
            column.setFilterValue('');
            return;
        }
        const option = innerOptions.find((option) => option.value === newValue);
        option && column.setFilterValue(option.value);
    };
    return (React.createElement(Dropdown, { value: columnFilterValue, options: innerOptions, onChange: hanldeFilterChange, onClick: (e) => e.stopPropagation() },
        React.createElement("div", { className: cx('container'), onClick: (e) => e.stopPropagation() },
            React.createElement(TableFilter, { className: iconClassNames }))));
};

export { Filter };
//# sourceMappingURL=Filter.js.map
